// $('.markers-box-wrapper').click(function() {
//     $(this).fadeOut(400);
// });
//
// $('.markers-box-wrapper').click(function() {
//     event.stopPropagation();
// });

google.maps.event.addDomListener(window, 'load', initGM);

var $markersData = [];
var group = group || 'skupina';
var points = points || [];
var $mapMarkers = $mapMarkers || [];

var iconWidth = 42;
var iconHeight = 55;

// výchozí bod pokud nejsou nastaveny žádné jiné body
if (!points.length) {
    points.push({
        "title":   mapPointTitle,
        "address": mapPointAddress,
        "city":    mapPointCity,
        "phone":   mapPointPhone,
        "www":     mapPointWWW,
        "type":    'skupina',
        "lat":     mapPointLat,
        "lng":     mapPointLong
    });
}

// ikonky pro jednotlive typy markeru
var icons = [
    {
        name: group,
        //url:  basePath + "/skins/default-2/css/images/pointer.png",
        url:  distPath + "/images/pointer.png",
        size: new google.maps.Size(iconWidth, iconHeight)
    }
];

//ikonky pro nahrazeni/zvyrazneni
var replacementIcons = [
    {
        name: group,
        // url:  basePath + "/skins/default-2/css/images/pointer-selected.png",
        url:  distPath + "/images/pointer-selected.png",
        size: new google.maps.Size(iconWidth, iconHeight)
    }
];

/* mapy.cz */
function init() {

    if(document.getElementById('js-mapa-prodejny')) {

        var obrazek = distPath + "/images/pointer.png";
        var center = SMap.Coords.fromWGS84(mapPointLong, mapPointLat);
        var m = new SMap(JAK.gel("js-mapa-prodejny"), center, 13);
        m.addDefaultLayer(SMap.DEF_BASE).enable();
        m.addDefaultControls();

        var layer = new SMap.Layer.Marker();
        m.addLayer(layer);
        layer.enable();

        var card = new SMap.Card();
        var contentString = '' + mapPointAddress + '<br>' +
            '' + mapPointCity + '<br>' +
            '' + mapPointPhone + '<br>' +
            '<a href="http://' + mapPointWWW + '" target="_blank">' +
            '' + mapPointWWW + '' +
            '</a>';
        card.getHeader().innerHTML = "<strong>" + mapPointTitle + "</strong>";
        card.getBody().innerHTML = contentString;

        var sync = new SMap.Control.Sync();
        m.addControl(sync);

        var options = {
            url: obrazek,
            title: mapPointTitle
        };
        var marker = new SMap.Marker(center, "myMarker", options);
        marker.decorate(SMap.Marker.Feature.Card, card);
        layer.addMarker(marker);

    }

}

function initGM() {

    var $mapStyles = [
        {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#7c8391"
                }
            ]
        },
        {
            "featureType": "landscape.man_made",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#f1f1f1"
                }
            ]
        },
        {
            "featureType": "landscape.man_made",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#c7c7c7"
                }
            ]
        },
        {
            "featureType": "landscape.natural",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": "-100"
                },
                {
                    "lightness": "28"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#e0e0e0"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#a8a8a8"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#bbd9e5"
                }
            ]
        }
        ];

    //blank map styles
    // $mapStyles = [];

    // https://developers.google.com/maps/documentation/javascript/reference#MapOptions
    var mapOptions = {

        scrollwheel:           false,
        mapTypeControlOptions: {
            style:    google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.TOP_RIGHT
        },
//        mapTypeControl: false,
        zoomControl:           true,
        streetViewControl:     true,

        // How you would like to style the map.
        styles: $mapStyles
    };

    var $selectedMarker = window.location.hash;
    var $selectedMarkerIndex = 0;

    // Get the HTML DOM element that will contain your map.
    var map_canvas = $('#js-mapa-prodejny');
    if (map_canvas.length == 0) {
        return;
    }

    // pokud je dostupná pouze výchozí bod, nastav zoom a středový bod mapy (jinak se vše automaticky dopočítává podle bodů v mapě)
    if (points.length <= 1) {
        console.log(mapPointLat+','+mapPointLong);
        mapOptions.zoom = 11;
        mapOptions.center = new google.maps.LatLng(mapPointLat,mapPointLong); // startovni bod, REQUIRED
    }

    // Create the Google Map using our element and options.
    var map = new google.maps.Map(map_canvas.get(0), mapOptions);

    // Info boxes.
    var bounds = new google.maps.LatLngBounds();
    var $infoWindows = [];

    for (var $i = 0; $i < $mapMarkers.length; $i++) {

        var $icon = getIcon(icons, $mapMarkers[$i].type);

        var marker = new google.maps.Marker({

            position:        new google.maps.LatLng($mapMarkers[$i].position.lat, $mapMarkers[$i].position.lng),
            marker_id:       $mapMarkers[$i]['marker_id'],
            marker_iterator: $i,
            type:            $mapMarkers[$i].type,
            title:           $mapMarkers[$i].title,
            box:             $mapMarkers[$i].box,
            icon:            $icon,
            address:         $mapMarkers[$i].address,
            city:            $mapMarkers[$i].city,
            phone:           $mapMarkers[$i].phone,
            www:             $mapMarkers[$i].www,
            zIndex:          $mapMarkers.length - $i
        });

        bounds.extend(new google.maps.LatLng($mapMarkers[$i].position.lat, $mapMarkers[$i].position.lng))
        $markersData[$i] = marker;

        var contentString = '<div class="map_content">' +
            '<strong>' + marker.title + '</strong><br>' +
            '' + marker.address + '<br>' +
            '' + marker.city + '<br>' +
            '' + marker.phone + '<br>' +
            '<a href="http://' + marker.www + '" target="_blank">' +
            '' + marker.www + '' +
            '</a>' +
            '</div>';

        var infoBubble = new google.maps.InfoWindow({
            content:         contentString,
            showclosebutton: true
        });

        $infoWindows[$i] = infoBubble;
    }

    if (points.length > 1) {
        map.fitBounds(bounds);
    }

    // Marker clusterer.
    var clusterStyles = [
        {
            textColor: '#313131',
            // url:       basePath + '/skins/default-2/css/images/pointer-cluster.png',
            url:       distPath + '/images/pointer-cluster.png',
            height:    32,
            width:     32
        }
    ];

    var mcOptions = {
        zoom:     13,
        gridSize: 50,
        maxZoom:  15,
        styles:   clusterStyles
    };

    var mc = new MarkerClusterer(map, $markersData, mcOptions);

    google.maps.event.addListener(mc, 'clusterclick', function (cluster) {
        hideInfoBoxes();
        map.setCenter(cluster.getCenter());
        map.setZoom(map.getZoom() + 3);
    });

    // Click events.
    for (var $i = 0; $i < $markersData.length; $i++) {
        GMAPS_addEventt($markersData[$i], $markersData, map, $infoWindows, $infoWindows[$i]);
    }
}

function GMAPS_addEventt($marker, $markersData, map, $infoWindows, infoBubble) {

    $marker.addListener('click', function () {

        for (var $i = 0; $i < $markersData.length; $i++) {
            $markersData[$i].setIcon(getIcon(icons, $markersData[$i].type));
            $($markersData[$i].box).fadeOut(400);
        }

        for (var $i = 0; $i < $infoWindows.length; $i++) {
            $infoWindows[$i].close();
        }

        $marker.setIcon(getIcon(replacementIcons, $marker.type));
        $($marker.box).fadeIn(400);

        infoBubble.open(map, $marker);

        // scroll - pro mobilni zarizeni only
        if ($(window).width() < 800) {

            $('html, body').animate({
                scrollTop: $($marker.box).offset().top - 40
            }, 500);
        }

    });
}

/**
 *
 * @param icons
 * @param type
 * @return {*}
 */
function getIcon(icons, type) {
    for (var i = 0; i < icons.length; i++) {
        if (icons[i].name == type) {
            return icons[i];
        }
    }
    return false;
}

function hideInfoBoxes() {
    $('.markers-box-wrapper').fadeOut();
}

for (var i = 0; i < points.length; i++) {

    $mapMarkers.push({
        "title":     points[i].title,
        "address":   points[i].address,
        "city":      points[i].city,
        "phone":     points[i].phone,
        "www":       points[i].www,
        "box":       "#_js-box-" + i,
        "marker_id": 'box-' + i,
        "type":      group,
        "position":  {
            "lat": points[i].lat,
            "lng": points[i].lng
        }
    });

}
